// extracted by mini-css-extract-plugin
module.exports = {"Menu":"DesktopMenu_Menu__2F_Yp","Active":"DesktopMenu_Active__3SbPn"};